/*
 * @Description:
 * @Version:
 * @Autor: yqf
 * @Date: 2021-11-02 18:23:52
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2026-07-20 14:24:05
 * @FilePath: \ysz_web_international_h5\src\router\index.js
 */
import Vue from "vue";
import Router from "vue-router";
import store from "../store";
//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
Vue.use(Router);

function routers() {
  const router = [
    {
      path: "/",
      name: "Home",
      component: () => import("../pages/Home/index.vue"),
      meta: {
        keepAlive: false,
        commonTop: true,
        footer: true,
        title: "MedJ",
      },
    },
    {
      path: "/articles",
      name: "Articles",
      component: () => import("../pages/Articles/index.vue"),
      meta: {
        keepAlive: false,
        commonTop: true,
        footer: true,
        title: "MedJ",
      },
    },
    {
      path: "/article",
      name: "Article",
      component: () => import("../pages/Article/index.vue"),
      meta: {
        keepAlive: false,
        commonTop: true,
        noSearch: true,
        footer: true,
        title: "MedJ",
      },
    },
    {
      path: "/article/share",
      name: "ArticleShare",
      component: () => import("../pages/Article/share/index.vue"),
      meta: {
        keepAlive: false,
        footer: true,
        title: "Share on WeChat",
        noSearch: true,
        commonTop: true
      },
    },
    {
      path: "/doctors",
      name: "Doctors",
      component: () => import("../pages/doctors/index.vue"),
      meta: {
        keepAlive: false,
        commonTop: true,
        footer: true,
        title: "Doctors",
      },
    },
    {
      path: "/conferences",
      name: "Conferences",
      component: () => import("../pages/conferences/index.vue"),
      meta: {
        keepAlive: false,
        commonTop: true,
        footer: true,
        title: "Conferences",
      },
    },
    {
      path: "/webinar",
      name: "Webinar",
      component: () => import("../pages/webinar/index.vue"),
      meta: {
        keepAlive: false,
        commonTop: true,
        footer: true,
        title: "Webinar",
      },
    },
    {
      path: "/conferences/content",
      name: "ConferencesContent",
      component: () => import("../pages/conferences/content.vue"),
      meta: {
        keepAlive: false,
        commonTop: true,
        footer: true,
        title: "Content Lists",
      },
    },
    {
      path: "/conferences/collection",
      name: "ConferencesCollection",
      component: () => import("../pages/conferences/collection.vue"),
      meta: {
        keepAlive: false,
        commonTop: true,
        footer: true,
        title: "Collection",
      },
    },

    {
      path: "/account",
      name: "Account",
      component: () => import("../pages/Account/index.vue"),
      meta: {
        keepAlive: false,
        commonTop: true,
        footer: true,
        title: "MedJ Account",
      },
    },
    {
      path: "/collection",
      name: "Collection",
      component: () => import("../pages/Collection/index.vue"),
      meta: {
        keepAlive: false,
        commonTop: true,
        footer: true,
        title: "MedJ Collection",
      },
    },
    {
      path: "/about",
      name: "About",
      component: () => import("../pages/About/index.vue"),
      meta: {
        keepAlive: false,
        commonTop: true,
        footer: true,
        title: "About MedJ",
      },
    },
    {
      path: "/about_wechat",
      name: "AboutWechat",
      component: () => import("../pages/About/wechat.vue"),
      meta: {
        keepAlive: false,
        footer: true,
        title: "About Wechat",
        noSearch: true,
        commonTop: true
      },
    },
    {
      path: "/search",
      name: "Search",
      component: () => import("../pages/Search/index.vue"),
      meta: {
        keepAlive: false,
        // commonTop: true,
        footer: true,
        title: "MedJ Search",
      },
    },
    {
      path: "/partnership",
      name: "Partnership",
      component: () => import("../pages/Partnership/index.vue"),
      meta: {
        keepAlive: false,
        commonTop: true,
        title: "Partnership",
        footer: true,
      },
    },
    {
      path: "/login_register",
      name: "LoginRegister",
      component: () => import("../pages/LoginRegister/index.vue"),
      meta: {
        keepAlive: false,
        buriedTitle: "Login Register",
        module: "LoginRegister",
        title: "MedJ Account",
      },
    },
    {
      path: "/input_information",
      name: "InputInformation",
      component: () => import("../pages/LoginRegister/InputInformation.vue"),
      meta: {
        keepAlive: false,
        buriedTitle: "Input Information",
        module: "LoginRegister",
        title: "MedJ Input Information",
      },
    },
    {
      path: "/welcome",
      name: "welcome",
      component: () => import("../pages/LoginRegister/welcome.vue"),
      meta: {
        keepAlive: false,
        buriedTitle: "welcome",
        module: "LoginRegister",
        title: "MedJ Welcome",
      },
    },
    {
      path: "/forgot_password",
      name: "forgotPassword",
      component: () => import("../pages/LoginRegister/forgotPassword.vue"),
      meta: {
        keepAlive: false,
        buriedTitle: "Forgot Password",
        module: "LoginRegister",
        title: "MedJ Forgot Password",
      },
    },
    {
      path: "/reset_password",
      name: "resetPassword",
      component: () => import("../pages/LoginRegister/resetPassword.vue"),
      meta: {
        keepAlive: false,
        buriedTitle: "Reset Password",
        module: "LoginRegister",
        title: "MedJ Reset Password",
      },
    },
    {
      path: "/reset_password_success",
      name: "resetPasswordSuccess",
      component: () =>
        import("../pages/LoginRegister/resetPasswordSuccess.vue"),
      meta: {
        keepAlive: false,
        buriedTitle: "Reset Password",
        module: "LoginRegister",
        title: "MedJ Reset Password Success",
      },
    },
    {
      path: "/privacy",
      name: "Privacy",
      component: () => import("../pages/About/privacy.vue"),
      meta: {
        keepAlive: false,
        buriedTitle: "Privacy Policy",
        title: "MedJ Privacy  Policy",
      },
    },
    {
      path: "/terms",
      name: "Terms",
      component: () => import("../pages/About/terms.vue"),
      meta: {
        keepAlive: false,
        buriedTitle: "Terms of Use",
        title: "MedJ MedJ Terms of Use",
      },
    },
    {
      path: "/thirdParties",
      name: "thirdParties",
      component: () => import("../pages/About/thirdParties.vue"),
      meta: {
        keepAlive: false,
        buriedTitle: "thirdParties",
        title: "MedJ List of Third Parties",
      },
    },
    {
      path: "/privacy_us",
      name: "privacy_us",
      component: () => import("../pages/About/privacy_Us.vue"),
      meta: {
        keepAlive: false,
        buriedTitle: "privacyUs",
        title: "MedJ U.S. Privacy Policy",
      },
    },
    {
      path: "/privacy_europe",
      name: "privacy_europe",
      component: () => import("../pages/About/privacy_europe.vue"),
      meta: {
        keepAlive: false,
        buriedTitle: "privacyEurope",
        title: "MedJ Europe Privacy Policy",
      },
    },
    {
      path: "/innovation_tracker",
      name: "innovation_tracker",
      component: () => import("../pages/innovationTracker/index.vue"),
      meta: {
        keepAlive: false,
        buriedTitle: "innovationTracker",
        title: "MedJ Innovation Tracker",
        footer: true,
        commonTop: true,
      },
    },
    {
      path: "/innovation_tracker_deep_analysis",
      name: "innovation_tracker_deep_analysis",
      component: () => import("../pages/innovationTracker/deepAnalysis/index.vue"),
      meta: {
        keepAlive: false,
        buriedTitle: "innovationTrackerDeepAnalysis",
        title: "MedJ Innovation Tracker Deep Analysis",
        footer: true,
        commonTop: true,
      },
    },
    {
      path: "/innovation_tracker_latest_news",
      name: "innovation_tracker_latest_news",
      component: () => import("../pages/innovationTracker/latestNews/index.vue"),
      meta: {
        keepAlive: false,
        buriedTitle: "innovationTrackerLatestNews",
        title: "MedJ Innovation Tracker Latest News",
        footer: true,
        commonTop: true,
      },
    },
    {
      path: "/innovation_tracker_frontier_research",
      name: "innovation_tracker_frontier_research",
      component: () => import("../pages/innovationTracker/frontierResearch/index.vue"),
      meta: {
        keepAlive: false,
        buriedTitle: "innovationTrackerFrontierResearch",
        title: "MedJ Frontier Research",
        footer: true,
        commonTop: true,
      },
    },
  ];
  return router;
}

// router对象工厂
function routerFactory() {
  // 加载路由
  const router = routers();
  const routerObj = new Router({ routes: router });
  // 全局router守卫
  routerObj.beforeEach(async (to, from, next) => {
    console.log("to", to);
    if (
      to.path === "/login_register" &&
      !from.meta.module &&
      from.meta.module !== "LoginRegister"
    ) {
      localStorage.setItem("oldPath", from.fullPath);
    }
    if (localStorage.getItem("ysz_web_international_token")) {
      store.dispatch("setIsLogin", true);
      store.dispatch(
        "setUserInfo",
        JSON.parse(localStorage.getItem("userInfo"))
      );
    }
    if (to.meta.title) {
      console.log("to.meta.title", to.meta.title);
      document.title = to.meta.title;
    }
    // 滚动到顶部
    window.scrollTo(0, 0);
    next();
  });

  return routerObj;
}

export default routerFactory();
